import React from 'react'
import Link from 'gatsby-link'
import background from "../assets/img/bannerTransparent.png";

const Header = ({ siteTitle }) => (
  <div
    style={{
     // background: '#75AADB',
      marginBottom: '0',
      height: '5.2rem'
    }}
  >
    <div
      style={{
        margin: '0 auto',
        padding: '0rem 1rem', backgroundImage: `url(${background})`, backgroundPosition: 'center', marginBottom: 1
      }}
    >
      <h1 style={{ margin: 0, textAlign: 'right', paddingBottom: '12px' }}>
        <Link
          to="/"
          style={{
            color: '#FCBF49',
            fontFamily: "fantasy",
            textDecoration: 'none',
            textShadow: '2px 2px 0 #843511',
          }}
        >
          {siteTitle}
        </Link>
        <p style={{ color: '#3A3380', fontSize: '1rem', marginTop: '0.1rem', fontFamily: 'cursive'}}>
          Nuestra historia esperando por vos
        </p>
      </h1>
    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js